module.exports = __webpack_public_path__ + "static/media/Sol-min.9ec477e2.PNG";